import { Amplify } from 'aws-amplify';

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        region: 'us-west-1',
        userPoolClientId: '7r12he3ll17kedc0t8pq7hc5al',
        userPoolId: 'us-west-1_tv50QHqZj',
        loginWith: {
          oauth: {
            domain: 'janers.auth.us-west-1.amazoncognito.com',
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [
              'http://localhost:3000/login',
              'https://plpcsanjose.com/login',
              'https://dev.plpcsanjose.com/login',
              'https://purple-lotus-next.vercel.app/login'
            ],
            redirectSignOut: [
              'http://localhost:3000',
              'https://plpcsanjose.com',
              'https://dev.plpcsanjose.com',
              'https://purple-lotus-next.vercel.app'
            ],
            responseType: 'token',
          },
        },
      },
    },
    ssr: true,
  });
}